import React, { useEffect, useRef } from "react";
import { subjectParticle } from "../utils/format";
import "./FirstBookModal.css";

/**
 * 첫 책을 담은 직후 한 번.
 *
 * 여기까지 온 사람은 자기 행성에 책 한 권을 세웠을 뿐이라 아직 볼 것이
 * 없다. 이 앱이 무엇인지는 남의 행성에 들어가 봐야 알게 된다 — 책이 쌓인
 * 곳을 먼저 보여주고, 돌아올 자리로 내 행성을 알려준다.
 *
 * 책이 많은 순서로 세운다. 처음 온 사람에게 한 권짜리 행성을 권하면
 * 이 우주가 비어 있는 것처럼 보인다.
 */
const SHOW = 3;

export default function FirstBookModal({ book, users = [], uid, onUserClick, onGoMine, onClose }) {
  const modalRef = useRef(null);

  useEffect(() => {
    modalRef.current?.focus({ preventScroll: true });
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const planets = (users || [])
    .filter((u) => u.id !== uid && (u.bookIds || []).length > 0)
    .sort((a, b) => (b.bookIds || []).length - (a.bookIds || []).length)
    .slice(0, SHOW);

  return (
    <div className="fb-overlay" onClick={onClose}>
      <div className="fb-modal" role="dialog" aria-modal="true" aria-label="첫 책"
        ref={modalRef} tabIndex={-1} onClick={(e) => e.stopPropagation()}>
        <div className="fb-mark" aria-hidden="true">✦</div>
        <div className="fb-title">첫 책을 담았어요</div>
        {book?.title && (
          <div className="fb-book">『{book.title}』{subjectParticle(book.title)} 행성에 자리를 잡았습니다</div>
        )}

        {planets.length > 0 ? (
          <>
            <div className="fb-lead">
              이 우주에는 다른 행성도 있어요.
              <br />책이 쌓인 곳부터 구경해보세요.
            </div>
            <div className="fb-list">
              {planets.map((u) => (
                <button key={u.id} className="fb-planet" onClick={() => onUserClick(u.id)}>
                  <span className="fb-planet-av" aria-hidden="true">{u.avatar || "🪐"}</span>
                  <span className="fb-planet-txt">
                    <span className="fb-planet-n">{u.name}</span>
                    <span className="fb-planet-c">{(u.bookIds || []).length}권</span>
                  </span>
                  <span className="fb-planet-go" aria-hidden="true">→</span>
                </button>
              ))}
            </div>
          </>
        ) : (
          /* 아직 아무 행성도 없으면 권할 곳이 없다. 없는 것을 권하면
             빈 화면으로 데려가게 된다. */
          <div className="fb-lead">
            책을 더 담을수록 행성이 자랍니다.
          </div>
        )}

        <button className="fb-mine" onClick={onGoMine}>내 행성으로 가기</button>
        <button className="fb-later" onClick={onClose}>나중에</button>
      </div>
    </div>
  );
}
